/**
 * Settings → Profile tab. Identity as the IdP reports it; read-only.
 *
 * `||` rather than `??`: the backend builds these claims through
 * `_str_or_empty`, so an IdP that omits `name` yields '', not null. `??`
 * would pass the empty string through and render a blank row.
 */

import type { ReactElement } from 'react';
import { useAuth } from '@features/auth';

export function ProfileTab(): ReactElement {
  const { user } = useAuth();

  return (
    <section>
      <dl className="profile-details">
        <dt>Name</dt>
        <dd>{user?.name || '—'}</dd>
        <dt>Email</dt>
        <dd>{user?.email || '—'}</dd>
      </dl>
    </section>
  );
}
